import React, { useEffect, useState } from "react";
import userAPI from "../../api/UserApi";
import { showError, showSuccess } from "../../utils/toastUtils";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setAccessToken } from "../../api/axiosInstance";
import { handleApiValidationError } from "../../utils/apiErrorHandler";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Mail, Lock, UserPlus, User } from "lucide-react";

function ResetPassword() {
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token");

  useAlphabeticInput();

  const INITIAL_FORM_DATA = {
    newPassword: "",
    confirmPassword: "",
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(formData.email);
  const isValidPassword = formData.newPassword.length >= 6;

  const validate = () => {
    const newErrors = {};

    if (!formData.newPassword) {
      newErrors.newPassword = "Enter Password";
    } else if (!isValidPassword) {
      newErrors.newPassword = "Password must be at least 6 characters";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Enter Confirm Password";
    } else if (!isValidPassword) {
      newErrors.confirmPassword =
        "Confirm Password must be at least 6 characters";
    }

    if (formData.newPassword !== formData.confirmPassword) {
      newErrors.general = "Password & Confirm Password must be same";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (!token) {
      setMessage("Invalid reset link.");
      return;
    }
  }, [token])

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      const res = await userAPI.resetPassword(token, formData);
      if (res.code === 200) {
        showSuccess(res.message);
        navigate("/users/login");
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    }
  };

  return (
    <>
  <div className="custom-registerpage-wrapper">
  <Container fluid className="p-0">
    <Row className="g-0 custom-registerpage-row">

      {/* LEFT SIDE */}
      <Col
        lg={6}
        className="d-none d-lg-block custom-registerpage-imagebox"
      >
        <div className="register-image-overlay"></div>
      </Col>

      {/* RIGHT SIDE */}
      <Col
        lg={6}
        className="custom-registerpage-right"
      >
        <div className="custom-registerpage-formbox">

          <h1 className="custom-registerpage-title">
            Reset Password
          </h1>

          <p className="custom-registerpage-subtitle">
            Enter details to reset your password
          </p>

          <Form onSubmit={handleSubmit}>

            {/* PASSWORD */}
            <Form.Group
              className="custom-register-form-group"
              controlId="password"
            >
              <Form.Label className="custom-form-label">
                Password <span className="text-danger">*</span>
              </Form.Label>

              <div className="input-group-custom">
                <Lock
                  size={18}
                  className="input-icon"
                />

                <Form.Control
                  type="password"
                  name="newPassword"
                  placeholder="New Password"
                  value={formData.newPassword}
                  onChange={handleChange}
                />
              </div>

              {errors?.newPassword && (
                <span className="text-danger custom-input-span-text">
                  {errors.newPassword}
                </span>
              )}
            </Form.Group>

            {/* CONFIRM PASSWORD */}
            <Form.Group
              className="custom-register-form-group"
              controlId="confirmPassword"
            >
              <Form.Label className="custom-form-label">
                Confirm Password <span className="text-danger">*</span>
              </Form.Label>

              <div className="input-group-custom">
                <Lock
                  size={18}
                  className="input-icon"
                />

                <Form.Control
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </div>

              {errors?.password && (
                <span className="text-danger custom-input-span-text">
                  {errors.password}
                </span>
              )}
            </Form.Group>

            {/* GENERAL ERROR */}
            {errors?.general && (
              <div className="custom-reset-error">
                {errors.general}
              </div>
            )}

            {/* MESSAGE */}
            {message && (
              <div className="custom-reset-message">
                {message}
              </div>
            )}

            {/* BUTTON */}
            <Button
              className="custom-registerpage-submitbtn"
              type="submit"
            >
              RESET PASSWORD
            </Button>

          </Form>

        </div>
      </Col>

    </Row>
  </Container>
</div>
    </>
  );
}

export default ResetPassword;
